import React from 'react';
import { IStyleSettings } from 'types';
import Text from 'components/Text/Text';
import { StyleInputNew } from './StyleInputNew';
import classNames from 'classnames';

const getSectionWidthClass = (count: number) => {
	if (count === 1) {
		return 'w-1/4';
	}
	if (count === 2) {
		return 'w-1/2';
	}
	if (count === 3) {
		return 'w-3/4';
	}
	return 'w-full';
};

const getColorWidthClass = (count: number) => {
	if (count === 1) {
		return 'w-full';
	}
	if (count === 2) {
		return 'w-1/2';
	}
	if (count === 3) {
		return 'w-1/3';
	}
	return 'w-1/4';
};

interface IProps {
	sectionKey: string;
	colors: IStyleSettings[];
	setStyleSettings: (styleItemId: string, value: string, key: string) => void;
}

export const StyleSectionNew: React.FC<IProps> = ({ sectionKey, colors, setStyleSettings }) => (
	<div
		className={classNames('px-2 flex flex-col gap-2', getSectionWidthClass(colors.length))}
		data-test="StyleSection">
		<Text translationNameSpace="mediaSettings" translationKey={sectionKey} size="m" weight="bold" />
		<div className="-mx-2 flex flex-wrap gap-y-4">
			{colors.map((el) => (
				<div key={el.id} className={classNames('px-2', getColorWidthClass(colors.length))}>
					<StyleInputNew data={el} setStyleSettings={setStyleSettings} />
				</div>
			))}
		</div>
	</div>
);
